module.exports = __webpack_public_path__ + "img/single-2.8a6ec80f.png";